import { createContext, Dispatch, PropsWithChildren, ReactNode, SetStateAction, useMemo, useState } from 'react'

import { AppSpinner } from 'aem-libs-react-ts/src/inlet/AppSpinner'
import { Inlet } from 'aem-libs-react-ts/src/inlet/Inlet'
import AppConfig from 'aem-libs-react-ts/src/types/app-config'

import type { AppContextType, LoggingOptions } from './types'
import { getConfig } from 'aem-libs-react-ts/src/utils/getConfig'

export const initContextData = {
  appName: null as unknown as string,
  appSpinner: null as unknown as AppSpinner,
  paramsFile: null as unknown as AppConfig,
  error: null as unknown as boolean,
  setError: null as unknown as (value?: boolean) => void,
  setParamsDynamic: null as unknown as Dispatch<SetStateAction<object>>,
  loggingOptions: null as unknown as LoggingOptions
}

export const AppContext = createContext<AppContextType>(initContextData)

export interface IAppContextProviderProps {
  inlet: Inlet
  children: ReactNode
  loggingOptions?: LoggingOptions
}

export const AppContextProvider = ({
  children,
  inlet,
  loggingOptions
}: PropsWithChildren<IAppContextProviderProps>) => {
  const [error, setError] = useState(false)
  const [paramsDynamic, setParamsDynamic] = useState(null)

  const handleError = (value?: boolean) => setError(value ?? true)
  const contextInitValues = useMemo(() => {
    return {
      appName: inlet.appName,
      appSpinner: inlet.appSpinner,
      paramsFile: inlet.paramsFile ?? getConfig(),
      paramsStatic: inlet.getStaticParams(),
      error,
      paramsDynamic,
      setError: handleError,
      setParamsDynamic,
      loggingOptions
    } as Required<AppContextType>
  }, [inlet, paramsDynamic, error])

  return <AppContext.Provider value={contextInitValues}>{children}</AppContext.Provider>
}
